/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ available: NonNullable<unknown>, unit: NonNullable<unknown>, needed: NonNullable<unknown> }} Stock_Out_Lot_InsufficientInputs */

const vi_stock_out_lot_insufficient = /** @type {(inputs: Stock_Out_Lot_InsufficientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lô chỉ còn ${i?.available} ${i?.unit}, không đủ ${i?.needed} ${i?.unit}`)
};

/**

* @param {Stock_Out_Lot_InsufficientInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_lot_insufficient = /** @type {((inputs: Stock_Out_Lot_InsufficientInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Lot_InsufficientInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_lot_insufficient(inputs)
});